import React from 'react';
import styles from '../app.module.css'

const FormInput = ({ label, type = 'text', value, onChange }) => {
  return (
    <div className="form-group">
      <label>{label}</label>
      <input type={type} value={value} onChange={(e) => onChange(e.target.value)} />
    </div>
  );
};

export default FormInput;
